import { Component, OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { _MSGTYPES } from '../../../constant/msgType';
import echarts from 'echarts';
import { formatNumber } from '../../../utils/common';

@Component({
  selector: 'icc-total-biztype-send',
  templateUrl: './icc-total-biztype-send.component.html',
  styleUrls: ['./icc-total-biztype-send.component.less'],
})
export class IccTotalBiztypeSendComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}

  // 图谱实例
  chartIns: any;
  innerColors = ['#58d3ff', '#34a2ff', '#23d3a0', '#91ef7a', '#fbbb15', '#fb7649', '#e9ef00', '#7e85e6'];
  outterColors = [
    ['rgba(88, 211, 255, 1)', 'rgba(88, 211, 255, .8)', 'rgba(88, 211, 255, .6)', 'rgba(88, 211, 255, .4)', 'rgba(88, 211, 255, .2)'],
    ['rgba(52, 162, 255, 1)', 'rgba(52, 162, 255, .8)', 'rgba(52, 162, 255, .6)', 'rgba(52, 162, 255, .4)', 'rgba(52, 162, 255, .2)'],
    ['rgba(35, 211, 160, 1)', 'rgba(35, 211, 160, .8)', 'rgba(35, 211, 160, .6)', 'rgba(35, 211, 160, .4)', 'rgba(35, 211, 160, .2)'],
    ['rgba(145, 239, 122, 1)', 'rgba(145, 239, 122, .8)', 'rgba(145, 239, 122, .6)', 'rgba(145, 239, 122, .4)', 'rgba(145, 239, 122, .2)'],
    ['rgba(251, 187, 21, 1)', 'rgba(251, 187, 21, .8)', 'rgba(251, 187, 21, .6)', 'rgba(251, 187, 21, .4)', 'rgba(251, 187, 21, .2)'],
    ['rgba(251, 118, 73, 1)', 'rgba(251, 118, 73, .8)', 'rgba(251, 118, 73, .6)', 'rgba(251, 118, 73, .4)', 'rgba(251, 118, 73, .2)'],
  ];
  innerPieData: Array<{
    name: string; // 业务类型名称
    value: number; // 发送量
    valueStr: string; // 千分符格式化发送量
    radio: number; // 发送占比
    ranking: number; // 排名浮动：0为不变 1为上升 2为下降
    itemStyle: any; // 图形样式
  }>;
  outterPieData: Array<{
    name: string; // 消息类型名称
    value: number; // 消息类型发送量
    itemStyle: any; // 图形样式
  }>;
  // 数据源
  @Input() data: Array<{
    bizName: string; // 业务类型名称
    count: number; // 发送量
    radio: number; // 发送占比
    ranking: number; // 排名浮动：0为不变 1为上升 2为下降
    msgList: Array<{
      msgType: number;
      count: number;
    }>;
  }>;
  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };
  ngOnInit() {
    if (this.data instanceof Array && this.data.length) {
      setTimeout(() => {
        this.formatPieData();
        this.createLineChart('chart-el');
      }, 100);
    }
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  formatPieData() {
    const result = [];
    const innerPieData = [];
    const outterPieData = [];
    this.data.forEach((item: any, bizIndex: number) => {
      const tempBiz: any = {};
      tempBiz.name = item.bizName || item.name;
      tempBiz.value = item.count;
      tempBiz.valueStr = formatNumber(item.count);
      tempBiz.radio = item.ratio;
      tempBiz.ranking = item.ranking;
      tempBiz.itemStyle = {
        color: this.innerColors[bizIndex],
      };
      innerPieData.push(tempBiz);
      if (item.msgList instanceof Array) {
        item.msgList.forEach((_msgItem: any, msgIndex: number) => {
          const tempMsg: any = {};
          const msgItem = _MSGTYPES.getMsgByType(false, _msgItem.msgType);
          tempMsg.name = msgItem.name || '其他';
          tempMsg.value = _msgItem.count;
          tempMsg.itemStyle = {
            color: this.outterColors[bizIndex][msgIndex],
          };
          outterPieData.push(tempMsg);
        });
      }
    });
    this.innerPieData = innerPieData;
    this.outterPieData = outterPieData;
  }
  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}',
      },
      legend: {
        show: false,
      },
      series: [
        {
          type: 'pie',
          data: this.innerPieData,
          label: {
            position: 'inside',
            formatter: '{d}%',
          },
          radius: [0, 60],
          itemStyle: {
            borderWidth: 0,
            borderColor: '#FFFFFF',
          },
          clockwise: true,
          animation: false,
        },
        {
          type: 'pie',
          data: this.outterPieData,
          radius: [60, 110],
          itemStyle: {
            borderWidth: 0,
            borderColor: '#FFFFFF',
          },
          animation: false,
          label: {
            normal: {
              formatter: params => {
                return '{b| ' + params.name + '}  ' + '{c|' + params.percent.toFixed(2) + '%}';
              },
              borderWidth: 0,
              borderRadius: 4,
              padding: [0, -80, 0, -80],
              height: 30,
              fontSize: 12,
              align: 'center',
              color: '#9ea8c8',
              rich: {},
            },
            alignTo: 'none',
          },
          labelLine: {
            length2: 80,
            lineStyle: {
              color: '#eaecf0',
            },
          },
        },
      ],
    });
  }
}
